import React from "react";
import Modal from "../../Atoms/Modal/Modal";
import styles from "./MemberInfo.module.scss";
import calendarIcon from "../../../assets/Imagess/calendar-black.svg";
import Buttons from "../../Atoms/Buttons/Buttons";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import { sanitizeAndValidateUrl } from "../../../app/helpers/sanitizeAndValidateUrl";

const MemberInfo = ({ data, handleOnClose, setShowDeletePopup, selected }) => {
  const navigate = useNavigate();

  return (
    <Modal
      onClose={handleOnClose}
      width="559px"
      modalInnerContainerStyle={{ padding: '0px', gap: '0px' }}
      closeStyle={{ top: '25px', right: '25px' }}
    >
      <div>
        <img
          src={sanitizeAndValidateUrl(`${data?.url}${data?.teamImage}`)}
          className={styles['modal-image']}
        />
      </div>
      <div className={styles['info-container']}>
        <div className={styles['row']}>
          <div>
            <p className={styles['key']}>Name</p>
            <p className={styles['value']}>{data?.fullName_EN}</p>
            <p className={styles['key']}>Position</p>
            <p className={styles['value']}>
              {!isEmpty(data?.position_DisplayEN)
                ? data?.position_DisplayEN
                : '-'}
            </p>
            <p className={styles['key']}>Member Category</p>
            <p className={styles['value']}>
              {!isEmpty(data?.category_DisplayEN)
                ? data?.category_DisplayEN
                : '-'}
            </p>
          </div>
        </div>
        <div className={styles['button-container']}>
          <Buttons
            text="تعديل"
            color="#0DA06E"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() =>
              navigate(
                `/home/edit-council-member/${
                  'students' === selected
                    ? 0
                    : 'parents' === selected
                    ? 1
                    : 'cadets-students' === selected
                    ? 2
                    : 'faculty-members' === selected
                    ? 3
                    : 4
                }/${data?.councilTeamId}`
              )
            }
          />
          <Buttons
            text="حذف"
            color="#D72222"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => {
              handleOnClose();
              setShowDeletePopup(true);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default MemberInfo;
